// extracted by mini-css-extract-plugin
module.exports = {"base":"booleanTextGroup_base__36zDw","note":"booleanTextGroup_note__35XI-"};